import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles.css';

const container = document.getElementById('root');
if (container === null) {
  // Not silent: an index.html without #root is a build problem, and a blank
  // page with nothing in the console is the worst way to find that out.
  throw new Error('mount-watch UI: #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
